// extracted by mini-css-extract-plugin
export var mt0 = "widget-breadcrumbs-module--mt-0--e3ec8";
export var mt1 = "widget-breadcrumbs-module--mt-1--5c168";
export var mt2 = "widget-breadcrumbs-module--mt-2--2b8c0";
export var mt3 = "widget-breadcrumbs-module--mt-3--3b713";
export var mt4 = "widget-breadcrumbs-module--mt-4--69461";
export var mt5 = "widget-breadcrumbs-module--mt-5--762bd";
export var mt6 = "widget-breadcrumbs-module--mt-6--6aef1";
export var widgetBreadcrumbs = "widget-breadcrumbs-module--widget-breadcrumbs--fea0a";
export var widgetBreadcrumbs__icon = "widget-breadcrumbs-module--widget-breadcrumbs__icon--40692";
export var widgetBreadcrumbs__link = "widget-breadcrumbs-module--widget-breadcrumbs__link--418f6";